import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Input, message, Row, Select, Spin } from 'antd';
import MessageConfirmModal from '../../components/messageModal/MessageConfirmModal';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { getDataRequest, postDataRequest, putDataRequest } from '../../api/serviceMethods';
import { COURSE_CATEGORY_URL, COURSE_URL, UPLOAD_VIDEO_COURSE_PUBLIC_URL, UPLOAD_VIDEO_COURSE_URL } from '../../api/URLs';
import _ from 'lodash';
import HeaderTeacherComponent from '../header/HeaderTeacherComponent';
import TextAreaComponent from '../input/TextAreaComponent';
import DragUploadCourseComponentVideo from '../upload/DragUploadCourseComponentVideo';
import DragUploadTeacherComponentVideo from '../upload/DragUploadTeacherComponentVideo';
import DragUploadComponent from '../upload/DragUploadComponent';
import UploadTeacherComponent from '../upload/UploadTeacherComponent';
import OSSUploadWrapper from '../upload/OSSUploadWrapper';



function EducationCourseUpload() {
    const { t } = useTranslation();
    const messageModalRef = useRef("");
    const navigate = useNavigate();
    const { id } = useParams();
    const [picUrl, setpicUrl] = useState("")
    const [loading, setLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false)
    const [searchParams] = useSearchParams();
    const teacherId = searchParams.get("id");
    const [dataObject, setDataObject] = useState({
        teacherId: teacherId,
        title: "",
        intro: "",
        videoFile: "",
        videoDuration: "", // seconds
        categoryId: "",
        validityPeriod: "",
        price: "",
        priceTerms: "",
        picUrl: "",
        privateFile: {
            url: "",
            size: "",
            fileName: "",
            duration: "",
            thumbnail: ""
        },
        publicFile: {
            url: "",
            size: "",
            fileName: "",
            duration: "",
            thumbnail: ""
        }
    });

    const [privateFile, setPrivateFiles] = useState([]);
    const [pupblicFile, setPupblicFiles] = useState([]);
    const [categoryId, setCategoryId] = useState([]);

    const fetchCategory = async () => {
        return await getDataRequest(`${COURSE_CATEGORY_URL}`, {}).then((res) => {
            if (res.status === 200) {
                const datas = res?.data
                    ? res.data.map((it) => ({
                        label: it.name || "",
                        value: it._id, // ✅ only send _id as value
                    }))
                    : [];
                setCategoryId(datas);
            }
        });
    };

    const addNewValue = async (data) => {
        setpicUrl(data?.picUrl);
        let objectValue = {
            ...dataObject,
            teacherId: data?.teacherId && data?.teacherId._id ? data?.teacherId._id : "",
            title: data?.title,
            intro: data?.intro,
            videoFile: data?.videoFile,
            videoDuration: data?.videoDuration, // seconds
            categoryId: data?.categoryId && data?.categoryId._id ? data?.categoryId._id : "",
            validityPeriod: data?.validityPeriod,
            price: data?.price,
            priceTerms: data?.priceTerms,
            picUrl: data?.picUrl,
            privateFile: {
                url: data?.videoFile ?? "",
                size: data?.videoSize ?? "",
                fileName: data?.videoName ?? "",
                duration: data?.videoDuration ?? "",
                thumbnail: data?.picUrl ?? ""
            },
            publicFile: {
                url: data?.previewVideo?.url ?? "",
                size: data?.previewVideo?.size ?? "",
                fileName: data?.previewVideo?.fileName ?? "",
                duration: data?.previewVideo?.videoDuration ?? "",
                thumbnail: data?.picUrl ?? ""
            }
        };

        setDataObject({
            ...objectValue,
        })

        data?.videoFile  && setPrivateFiles([{
            "url": data?.videoFile ?? "",
            "size": data?.videoSize ?? "",
            "name": data?.videoName ?? "",
            "uid": data?.uploadedTS || new Date(),
            duration: data?.videoDuration ?? "",
            thumbnail: data?.picUrl ?? ""
        }]);

        data?.previewVideo?.url && setPupblicFiles([{
            "url": data?.previewVideo?.url ?? "",
            "size": data?.previewVideo?.size ?? "",
            "name": data?.previewVideo?.fileName ?? "",
            "uid": data?.previewVideo?.uploadedTS || new Date(),
            duration: data?.previewVideo?.videoDuration ?? "",
            thumbnail: data?.picUrl ?? ""
        }]);
    }

    const getDetailById = async () => {
        setLoading(true)
        await getDataRequest(`${COURSE_URL}/${id && id}`)
            .then((res) => {
                setLoading(false)
                if (res.status === 200) {
                    addNewValue(res.data)
                }
            })
            .catch((err) => {
                setLoading(false)
            })
    }


    
    useEffect(() => {
        fetchCategory()
        id && getDetailById()
    }, [id])

    const checkError = () => {
        if (
            !dataObject.teacherId ||
            !dataObject.title ||
            !dataObject.intro ||
            !dataObject?.privateFile?.url ||
            !dataObject?.publicFile?.url ||
            !dataObject.categoryId || 
            !dataObject.validityPeriod ||
            !dataObject.price || 
            !dataObject.priceTerms || !picUrl
        ) {
            return true
        }
        return false
    }

    const insertParams = () => {
        return {
            teacherId: dataObject.teacherId,
            title: dataObject.title,
            intro: dataObject.intro,
            categoryId: dataObject.categoryId,
            validityPeriod: dataObject.validityPeriod,
            price: dataObject.price,
            priceTerms: dataObject.priceTerms,
            picUrl: picUrl || dataObject.privateFile?.thumbnail,
            videoFile: dataObject.privateFile?.url,
            videoDuration: dataObject.privateFile?.duration, // seconds
            "videoSize": dataObject.privateFile?.size,
            "videoName": dataObject.privateFile?.fileName,
            previewVideo: {
                url: dataObject.publicFile?.url,
                size: dataObject.publicFile?.size, // in bytes
                fileName: dataObject.publicFile?.fileName // in seconds
            }
        }
    }
    const handleSubmit = async () => {
        setIsSubmit(true)
        if (checkError()) {
            return false
        }
        setIsSubmit(false)
        setLoading(true);
        const params = insertParams()
        try {
            const res = await postDataRequest(COURSE_URL, params);

            if (res?.status === 200) {
                messageModalRef.current.showSuccessConfirmsAutoClose(res?.message || t("Saved Successfully"), () => { }, "", true);
                navigate(`/education-course?id=${teacherId}`)
            } else {
                messageModalRef.current.showWarningConfirmsAutoClose(res?.message || res.message || t("An error occurred."), () => { }, "", true);
            }
        } catch (err) {
            console.log(`err`, err)
            messageModalRef.current.showWarningConfirmsAutoClose(err && err?.message || "Server Error!", () => { }, "", true);
        } finally {
            setLoading(false);
        }
    }

    const hadleUpdate = async () => {
        setIsSubmit(true)
        if (checkError()) {
            return false
        }
        setIsSubmit(false)
        setLoading(true);
        let params = insertParams();
        try {
            const res = await putDataRequest(`${COURSE_URL}/${id}`, params);
            if (res?.status === 200) {
                messageModalRef.current.showSuccessConfirmsAutoClose(res.message || t("Saved Successfully"), () => { }, "", true);
                navigate(`/education-course?id=${teacherId}`)
            } else {
                messageModalRef.current.showWarningConfirmsAutoClose(res.message || res.message || t("An error occurred."), () => { }, "", true);
            }
        } catch (err) {
            console.log(`err`, err)
            messageModalRef.current.showWarningConfirmsAutoClose(err && err && err.message || "Server Error!", () => { }, "", true);
        } finally {
            setLoading(false);
        }
    }

    const handleChangeValue = (e) => {
        setDataObject((v) => ({ ...v, [e.target.name]: e.target.value ?? "" }));
    }

    const handleChangePrivateFile = (value) => {
        if(value[0]?.thumbnail) {
            setpicUrl(value[0]?.thumbnail ?? "");
        }
        setPrivateFiles(value);

        if(pupblicFile && pupblicFile.length > 0 && value[0]?.thumbnail) {
            pupblicFile[0].thumbnail = value[0]?.thumbnail ?? ""
            setPupblicFiles([...pupblicFile])
            if (dataObject.publicFile) {
                dataObject.publicFile.thumbnail = value[0]?.thumbnail ?? ""
                setDataObject({...dataObject});
            }
        }
        
        setDataObject((v) => ({
            ...v,
            privateFile: {
                "url": value[0]?.url ?? "",
                "size": value[0]?.size ?? "",
                "fileName": value[0]?.name ?? "",
                duration: value[0]?.duration ?? "",
                thumbnail: value[0]?.thumbnail ?? "",
            }
        }));

    }

    const handleChangePupblicFile = (value) => {
        if(value[0]?.thumbnail) {
            value[0].thumbnail = picUrl ? picUrl : value[0]?.thumbnail ?? ""
        }
        setPupblicFiles(value);
        setDataObject((v) => ({
            ...v,
            publicFile: {
                "url": value[0]?.url ?? "",
                "size": value[0]?.size ?? "",
                "fileName": value[0]?.name ?? "",
                duration: value[0]?.duration ?? "",
                thumbnail: picUrl ? picUrl : value[0]?.thumbnail ?? "",
            }
        }));
    }


    const handleChangeCover = (value) => {
        setpicUrl(value.url)
        dataObject.picUrl = value.url
        if(privateFile && privateFile.length > 0 && value.url) {
            privateFile[0].thumbnail = value.url
            setPrivateFiles([...privateFile]);
        }
        if(pupblicFile && pupblicFile.length > 0 && value.url) {
            pupblicFile[0].thumbnail = value.url
            setPupblicFiles([...privateFile]);
        }
        if(dataObject.privateFile) {
            dataObject.privateFile.thumbnail = value.url
        }
        if(dataObject.publicFile) {
            dataObject.publicFile.thumbnail = value.url
        }
        setDataObject({...dataObject});
    }

    return (
        <>
            <HeaderTeacherComponent
                backgroundColor="#E50A47"
                border="1px solid #e72158"
                isHide="view"
                onClick={() => navigate(`/education-course?id=${teacherId}`)}
                backTitle={t("Upload course videos")}
                hideTitle="userDetails"
                bntTitle1={t("Submit")}
                opacity="0.5px"
                color="#FFFFFF"
                onClick1={() => {
                    !id ? handleSubmit() : hadleUpdate();
                }}
            >
                <Spin spinning={loading} fullscreen></Spin>
                <div className='container newDetail' style={{width:"50%"}}>
                    <Row>
                        <Col md={24}>
                            <Row>
                                <div className='w-100'>
                                    <Row align="" className='mt-3'>
                                        <Col md={6} span={5} className='userLabel'>{t('Video files')}:</Col>
                                        <Col md={18} className="text-capitalize">

                                            <div className='w-100 file-border'>
                                            <Row align="" className='mt-3'>
                                                <Col md={6} span={5} className='userLabel'><span>{t('Full Video')}:</span></Col>
                                                <Col md={18} className="text-capitalize">
                                                    <OSSUploadWrapper
                                                        onUploadSuccess={(result) => {
                                                            handleChangePrivateFile([result]);
                                                        }}
                                                    >
                                                        <DragUploadTeacherComponentVideo
                                                            privateFile={true}
                                                            previewUrl={picUrl || ""}
                                                            fileList={privateFile}
                                                            setFileList={handleChangePrivateFile}
                                                            maxSize={50}
                                                            apiUrl={UPLOAD_VIDEO_COURSE_URL}
                                                            isview={true}
                                                        />
                                                    </OSSUploadWrapper>
                                                </Col>
                                            </Row>
                                            <Row align="" className='mt-3'>
                                                <Col md={6} span={5} className='userLabel'>
                                                <span>{t('Preview Video')}:</span> <br />
                                                <span>{t('30s')}</span>
                                                </Col>
                                                <Col md={18} className="text-capitalize">
                                                    <OSSUploadWrapper
                                                        onUploadSuccess={(result) => {
                                                            handleChangePupblicFile([result]);
                                                        }}
                                                    >
                                                        <DragUploadTeacherComponentVideo
                                                            privateFile={true}
                                                            previewUrl={picUrl || ""}
                                                            fileList={pupblicFile}
                                                            setFileList={handleChangePupblicFile}
                                                            maxSize={50}
                                                            apiUrl={UPLOAD_VIDEO_COURSE_PUBLIC_URL}
                                                            isview={true}
                                                        />
                                                    </OSSUploadWrapper>
                                                </Col>
                                            </Row>
                                            </div>

                                        </Col>
                                    </Row>
                                    <Row align="" className='mt-3'>
                                        <Col md={6} span={5} className='userLabel'>{t('Thumbnail')}:</Col>
                                        <Col md={18} className="text-capitalize">
                                             <div className='w-100' style={{maxWidth: "9rem"}}>
                                                <OSSUploadWrapper
                                                    onUploadSuccess={handleChangeCover}
                                                >
                                                    <UploadTeacherComponent
                                                        fileList={picUrl ? [{
                                                            "uid": "1",
                                                            "name": "",
                                                            "status": "done",
                                                            "url": picUrl
                                                        }] : []}
                                                        setFileList={handleChangeCover}
                                                        hideAvatarTitle={true}
                                                        changeAvatarTitle={t("Upload Thumbnail")}
                                                        uploadavatarTitle={t("Upload Thumbnail")}
                                                    />
                                                </OSSUploadWrapper>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row align="middle" className='mt-3'>
                                        <Col md={6} span={5} className='userLabel'>{t('Title Course')}:</Col>
                                        <Col md={18} className="text-capitalize">
                                            <Input
                                                value={dataObject.title}
                                                placeholder=""
                                                size="large"
                                                name='title'
                                                status={isSubmit && !dataObject.title && `error`}
                                                onChange={handleChangeValue}
                                                style={{
                                                    width: "100%"
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                    <Row align="middle" className='mt-3'>
                                        <Col md={6} span={5} className='userLabel'>{t('Course Description')}:</Col>
                                        <Col md={18} className="text-capitalize">
                                            <TextAreaComponent status={isSubmit && !dataObject.intro ? "error" :""} value={dataObject.intro} setValue={(value) => setDataObject({ ...dataObject, intro: value })} />
                                        </Col>
                                    </Row>
                                    <Row align="middle" className='mt-3'>
                                        <Col md={6} span={5} className='userLabel'>{t('Category')}:</Col>
                                        <Col md={18} className="text-capitalize">
                                            <Select
                                                className="singleCus"
                                                size="large"
                                                status={isSubmit && !dataObject.categoryId && "error"}
                                                placeholder="Select category"
                                                onChange={(value) => setDataObject((v) => ({ ...v, categoryId: value }))} // ✅ handle single value
                                                style={{ width: "100%" }}
                                                options={categoryId}
                                                value={dataObject.categoryId}
                                            />
                                        </Col>
                                    </Row>
                                    <Row align="middle" className='mt-3'>
                                        <Col md={6} span={5} className='userLabel'>{t('Course validity period')}:</Col>
                                        <Col md={6} className="text-capitalize">
                                            <Input
                                                value={dataObject.validityPeriod}
                                                placeholder=""
                                                size="large"
                                                name='validityPeriod'
                                                status={isSubmit && !dataObject.validityPeriod && `error`}
                                                onChange={handleChangeValue}
                                                type='number'
                                                style={{
                                                    width: "100%"
                                                }}
                                            />
                                        </Col>
                                        <Col md={2} style={{marginLeft:"1rem", color:"#636e88"}}>{t("day")}</Col>
                                    </Row>
                                    <Row align="middle" className='mt-3'>
                                        <Col md={6} span={5} className='userLabel'>{t('Course Price')}:</Col>
                                        <Col md={6} className="text-capitalize">
                                            <Input
                                                value={dataObject.price}
                                                placeholder=""
                                                size="large"
                                                type='number'
                                                name='price'
                                                status={isSubmit && !dataObject.price && `error`}
                                                onChange={handleChangeValue}
                                                style={{
                                                    width: "100%"
                                                }}
                                            />
                                        </Col>
                                        <Col md={2} style={{marginLeft:"1rem", color:"#636e88"}}>{t("yuan")}</Col>
                                    </Row>
                                    <Row align="middle" className='mt-3 mb-5'>
                                        <Col md={6} span={5} className='userLabel'>{t('Price Terms')}:</Col>
                                        <Col md={18} className="text-capitalize">
                                            <TextAreaComponent status={isSubmit && !dataObject.priceTerms ? "error" :""} value={dataObject.priceTerms} setValue={(value) => setDataObject({ ...dataObject, priceTerms: value })} />
                                        </Col>
                                    </Row>
                                </div>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </HeaderTeacherComponent>
            <MessageConfirmModal textCentered ref={messageModalRef} />
        </>
    );
}

export default EducationCourseUpload;
